/* CreditCost — "About N credits" next to a tool's run button.
 *
 * An estimate (config/creditCosts.js): a run is charged by what it really cost.
 * Hidden for guests, who do not use credits. No emoji.
 */

import { useAuth } from '../context/AuthContext'
import { creditCostLabel } from '../config/creditCosts'
import { JAI_COLORS, JAI_FONTS } from './JaiBrand'

// Imports JaiBrand, not JaiV2: JaiV2's buttons render this label, and importing
// JaiV2 back would be a circular import.

export default function CreditCost({ tool, style = {} }) {
  const { isGuest } = useAuth()
  const label = creditCostLabel(tool)
  if (!label || isGuest) return null
  return (
    <span style={{ fontSize: 11.5, color: JAI_COLORS.mute, fontFamily: JAI_FONTS.mono, whiteSpace: 'nowrap', ...style }}>
      {label}
    </span>
  )
}
